import axios from 'axios';
import config from '../config';

const baseUrl = config.baseUrl + '/api';
const insertClasificacion = async (descripcion) => {
    try {
        const response = await axios.post(`${baseUrl}/insertar-clasificacion`, { descripcion });
        return response.data; // Retorna el resultado del backend
    } catch (error) {
        console.error('Error al insertar en clasificacion:', error);
        throw error;
    }
};

const insertDesagregacion = async (descripcion) => {
    try {
        const response = await axios.post(`${baseUrl}/insertar-desagregacion`, { descripcion });
        return response.data;
    } catch (error) {
        console.error('Error al insertar en desagregacion:', error);
        throw error;
    }
};

const insertPeriodicidad = async (descripcion) => {
    try {
        const response = await axios.post(`${baseUrl}/insertar-periodicidad`, { descripcion });
        return response.data;
    } catch (error) {
        console.error('Error al insertar en periodicidad:', error);
        throw error;
    }
};

const insertTipoResultado = async (tipoResultado) => {
    try {
        const response = await axios.post(`${baseUrl}/insertar-tipo-resultado`, { tipoResultado });
        return response.data;
    } catch (error) {
        console.error('Error al insertar en tipo_resultado:', error);
        throw error;
    }
}


export {
    insertTipoResultado,
    insertPeriodicidad,
    insertDesagregacion,
    insertClasificacion
};